export default "__VITE_ASSET__4ui$OgT6pBc8ys_iMN8YZQ__"